import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { cancelWatch, fetchWatch, fetchWatches } from "@/lib/api";

export function useWatches(
  scope: "active" | "all" = "active",
  ownerScope: "personal" | "all" = "personal",
) {
  return useQuery({
    queryKey: ["watches", scope, ownerScope],
    queryFn: () => fetchWatches(scope, ownerScope),
    refetchInterval: 15_000,
  });
}

export function useWatch(id: string | null) {
  return useQuery({
    queryKey: ["watch", id],
    queryFn: () => fetchWatch(id!),
    enabled: !!id,
    refetchInterval: (query) => {
      const isRunning = query.state.data?.triggers.some(
        (trigger) => trigger.status === "pending" || trigger.status === "processing",
      );
      return isRunning ? 5_000 : 15_000;
    },
  });
}

export function useCancelWatch() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: cancelWatch,
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: ["watches"] });
      queryClient.invalidateQueries({ queryKey: ["watch", id] });
    },
  });
}
